import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="nk-footer" style={{ position: 'relative', width: '100%', backgroundColor: 'transparent' }}>
      {/* Fond qui s'étend jusqu'au bord droit de l'écran (compense la scrollbar) */}
      <div
        style={{
          position: 'absolute',
          left: 0,
          right: 'calc(100% - 100vw)',
          top: 0,
          bottom: 0,
          backgroundColor: '#FBC02D',
          zIndex: -1,
        }}
      />
      <div className="container-fluid">
        <div className="nk-footer-wrap">
          <div className="nk-footer-copyright">
            {" "}
            &copy; 2026 JBNHSE développé par <a href="https://jibuness.com">Jibuness</a>
          </div>
          <div className="nk-footer-links">
          </div>
        </div>
      </div>
    </div>
  );
};
export default Footer;
